/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsCustomRegistrationFieldDtoSchema } from "./customRegistrationFieldDtoSchema.ts";
import { goodLuckCoreDTOsDraftRankCostEntryDtoSchema } from "./draftRankCostEntryDtoSchema.ts";
import { goodLuckCoreDTOsPreDraftModeSchema } from "./preDraftModeSchema.ts";
import { goodLuckCoreDTOsPreDraftTimeoutActionSchema } from "./preDraftTimeoutActionSchema.ts";
import { goodLuckCoreDTOsPrizeDistributionRowDtoSchema } from "./prizeDistributionRowDtoSchema.ts";
import { goodLuckCoreDTOsScheduleDayDtoSchema } from "./scheduleDayDtoSchema.ts";
import { goodLuckCoreDTOsTournamentCapabilitiesDtoSchema } from "./tournamentCapabilitiesDtoSchema.ts";
import { goodLuckCoreDTOsTournamentOrganizerDtoSchema } from "./tournamentOrganizerDtoSchema.ts";
import { goodLuckCoreDTOsTournamentReactionsDtoSchema } from "./tournamentReactionsDtoSchema.ts";
import { goodLuckCoreDTOsTournamentWinnerDtoSchema } from "./tournamentWinnerDtoSchema.ts";
import { goodLuckCoreEntitiesWinnerPromotionModeSchema } from "../entities/winnerPromotionModeSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsTournamentResponseSchema = z.object({
  id: z.string().nullish(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  rules: z.string().nullish(),
  officialStreamChannel: z.string().nullish(),
  showPlayerStreamers: z.optional(z.boolean()),
  showOfficialStream: z.optional(z.boolean()),
  type: z.string().nullish(),
  bracketType: z.string().nullish(),
  enableThirdPlaceMatch: z.optional(z.boolean()),
  enableGrandFinal: z.optional(z.boolean()),
  startTimeTentative: z.optional(z.boolean()),
  prizePool: z.number().nullish(),
  prizeDescription: z.string().max(2000).nullish(),
  get prizeDistribution() {
    return z.array(goodLuckCoreDTOsPrizeDistributionRowDtoSchema).nullish();
  },
  createdById: z.string().nullish(),
  createdByName: z.string().nullish(),
  startDate: z.iso.datetime().nullish(),
  endDate: z.iso.datetime().nullish(),
  get scheduleDays() {
    return z.array(goodLuckCoreDTOsScheduleDayDtoSchema).nullish();
  },
  maxPlayers: z.int().nullish(),
  minTeamSize: z.int().nullish(),
  maxTeamSize: z.int().nullish(),
  maxTeamsInDraft: z.int().nullish(),
  arenaTeamCount: z.optional(z.int()),
  arenaGamesCount: z.optional(z.int()),
  arenaScoringJson: z.string().nullish(),
  arenaTeamMode: z.string().nullish(),
  arenaLobbyCount: z.optional(z.int()),
  arenaAssemblyState: z.string().nullish(),
  arenaCurrentRound: z.optional(z.int()),
  arenaTasksDocUrl: z.string().nullish(),
  requireRiotAccount: z.optional(z.boolean()),
  allowReplayRosterMatching: z.optional(z.boolean()),
  statsMode: z.string().nullish(),
  minRequiredRank: z.string().nullish(),
  status: z.string().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  registeredPlayersCount: z.optional(z.int()),
  manualWinnerMode: z.string().nullish(),
  defaultBestOf: z.optional(z.int()),
  finalBestOf: z.optional(z.int()),
  get preDraftMode() {
    return goodLuckCoreDTOsPreDraftModeSchema.optional();
  },
  get preDraftTimeoutAction() {
    return goodLuckCoreDTOsPreDraftTimeoutActionSchema.optional();
  },
  preDraftTurnSeconds: z.optional(z.int()),
  disabledChampionIds: z.array(z.string()).nullish(),
  hasBracket: z.optional(z.boolean()),
  isBracketPublished: z.optional(z.boolean()),
  bracketStatus: z.string().nullish(),
  format: z.string().nullish(),
  game: z.string().nullish(),
  currency: z.string().nullish(),
  location: z.string().nullish(),
  region: z.string().nullish(),
  currentTeams: z.optional(z.int()),
  maxTeams: z.optional(z.int()),
  image: z.string().nullish(),
  get organizer() {
    return goodLuckCoreDTOsTournamentOrganizerDtoSchema.optional();
  },
  enableDiscordIntegration: z.optional(z.boolean()),
  discordGuildId: z.string().nullish(),
  discordCategoryId: z.string().nullish(),
  discordNewsChannelId: z.string().nullish(),
  discordNewsChannelPublicReadOnly: z.optional(z.boolean()),
  discordDraftRoleId: z.string().nullish(),
  discordCaptainRoleId: z.string().nullish(),
  discordInMatchRoleId: z.string().nullish(),
  discordWinnerRoleId: z.string().nullish(),
  discordStreamerRoleId: z.string().nullish(),
  discordModeratorRoleId: z.string().nullish(),
  discordBracketChannelId: z.string().nullish(),
  broadcastBracketToDiscord: z.optional(z.boolean()),
  get winnerPromotionMode() {
    return goodLuckCoreEntitiesWinnerPromotionModeSchema.optional();
  },
  isDraftStarted: z.optional(z.boolean()),
  isDraftCompleted: z.optional(z.boolean()),
  draftCaptainBudget: z.int().nullish(),
  draftRankCosts: z.object({}).catchall(z.int()).nullish(),
  get draftRankCostEntries() {
    return z.array(goodLuckCoreDTOsDraftRankCostEntryDtoSchema).nullish();
  },
  draftStartTime: z.iso.datetime().nullish(),
  draftStartAt: z.iso.datetime().nullish(),
  draftStartedAt: z.iso.datetime().nullish(),
  draftLobbyOpenedAtUtc: z.iso.datetime().nullish(),
  isDraftBlocked: z.optional(z.boolean()),
  draftBlockedReason: z.string().nullish(),
  draftBlockedAtUtc: z.iso.datetime().nullish(),
  draftPickTimeoutSeconds: z.optional(z.int()),
  draftTimeoutAction: z.string().nullish(),
  draftNoPickAction: z.string().nullish(),
  draftType: z.string().nullish(),
  draftOrderMode: z.string().nullish(),
  registrationApprovalMode: z.string().nullish(),
  yellowCardsBeforeDisqualification: z.int().nullish(),
  redCardsBeforeDisqualification: z.int().nullish(),
  waitlistEnabled: z.optional(z.boolean()),
  waitlistMode: z.string().nullish(),
  waitlistPriorityRule: z.string().nullish(),
  get capabilities() {
    return goodLuckCoreDTOsTournamentCapabilitiesDtoSchema.optional();
  },
  allowCoachesInChannels: z.optional(z.boolean()),
  allowSubstitutesInChannels: z.optional(z.boolean()),
  allowStreamersInChannels: z.optional(z.boolean()),
  allowWebModeratorsInChannels: z.optional(z.boolean()),
  autoSendMatchStart: z.optional(z.boolean()),
  autoSendBracketProgress: z.optional(z.boolean()),
  autoSendRegistrationClose: z.optional(z.boolean()),
  autoStartMatches: z.optional(z.boolean()),
  matchStartDeadlineEnabled: z.optional(z.boolean()),
  pausesAllowedPerMatch: z.optional(z.int()),
  pauseDurationMinutes: z.optional(z.int()),
  useDynamicSchedule: z.optional(z.boolean()),
  roundBufferMinutes: z.int().nullish(),
  registrationOpenBeforeDays: z.optional(z.int()),
  registrationCloseBeforeMinutes: z.optional(z.int()),
  enableCheckIn: z.optional(z.boolean()),
  checkInWindowMinutes: z.optional(z.int()),
  get customRegistrationFields() {
    return z.array(goodLuckCoreDTOsCustomRegistrationFieldDtoSchema).nullish();
  },
  get reactions() {
    return goodLuckCoreDTOsTournamentReactionsDtoSchema.optional();
  },
  reviewCount: z.int().nullish(),
  get winner() {
    return goodLuckCoreDTOsTournamentWinnerDtoSchema.optional();
  },
});
